import constants from './constants.js';
import reduce from 'lodash/reduce';

const actions = reduce(
	constants.actionsData,
	(accumulator, element) => {
		accumulator[ `${element.id}` ] = (params, callback = {}) => {
			return {
				type: constants[ `LOAD_${element.id.toUpperCase()}` ],
				url: element.url,
				success: `${element.id}Loaded`,
				error: `${element.id}LoadingError`,
				params, // oggetto con parametri chiave->valore
				restParams: element.restParams,
				bodyParams: element.bodyParams,
				queryParams: element.queryParams,
				showLog: element.showLog,
				method: element.method,
				tokenRequired: element.tokenRequired,
				callback,
				setState: state => {
					let newState = { ...state };
					console.log(newState);
					console.log(element.id);
					newState[ element.id ].loading = true;
					newState[ element.id ].error = false;
					newState[ element.id ].value = false;
					return newState;
				}
			};
		};

		accumulator[ `${element.id}Loaded` ] = value => {
			return {
				type: constants[ `LOAD_${element.id.toUpperCase()}_SUCCESS` ],
				setState: state => {
					let newState = { ...state };
					newState[ element.id ].loading = false;
					newState[ element.id ].value = value.response ? value.response : value;
					return newState;
				},
				value
			};
		};

		accumulator[ `${element.id}LoadingError` ] = error => {
			return {
				type: constants[ `LOAD_${element.id.toUpperCase()}_ERROR` ],
				setState: state => {
					let newState = { ...state };
					newState[ element.id ].loading = false;
					newState[ element.id ].error = error;
					return newState;
				},
				error
			};
		};

		accumulator[ `${element.id}Clear` ] = error => {
			return {
				type: constants[ `LOAD_${element.id.toUpperCase()}_CLEAR` ],
				setState: state =>
					state
						.setIn([ `${element.id}`, 'value' ], false)
						.setIn([ `${element.id}`, 'loading' ], false)
						.setIn([ `${element.id}`, 'error' ], false),
				error
			};
		};
		return accumulator;
	},
	{}
);

export default actions;



// WEBPACK FOOTER //
// ./src/libraries/reducers/http-request/actions.js